export interface CompanyDetailsConfig {
    name: string;
    addressLine1: string;
    addressLine2: string;
    mobile: string;
    email: string;
    fbLink: string;
    tiktokLink: string;
    instaLink: string;
    bankName: string;
    branchName: string;
    bankAccountNo: string;
  }
  
  const companyDetailsConfig: CompanyDetailsConfig = {
    name: "Cozy Bud (Pvt) Ltd",
    addressLine1: "No.228/G/221, Sirigampola Rd,",
    addressLine2: "Thummodara, Nattandiya.",
    mobile: "+9474 3564344",
    email: "cozybudcontact@gmail.com",
    fbLink: "https://www.facebook.com/profile.php?id=61564896010095",
    tiktokLink: "https://www.tiktok.com/@cozybudtiktok",
    instaLink: "https://www.instagram.com/cozybudinsta",
    bankName: "Sampath Bank PLC (7278)",
    branchName: "Nattandiya (132)",
    bankAccountNo: "013210003120",
  };
  
  export default companyDetailsConfig;